/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CollectionModelProductMappingResponse } from '../../models/collection-model-product-mapping-response';
import { ProductMappingDto } from '../../models/product-mapping-dto';

export interface CreateProductMapping$Params {
      body: Array<ProductMappingDto>
}

export function createProductMapping(http: HttpClient, rootUrl: string, params: CreateProductMapping$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectionModelProductMappingResponse>> {
  const rb = new RequestBuilder(rootUrl, createProductMapping.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CollectionModelProductMappingResponse>;
    })
  );
}

createProductMapping.PATH = '/product-mappings';
